module.exports = __webpack_public_path__ + "img/free.bf5cb97b.jpg";